document.addEventListener("touchstart", function(e) {
  const card = e.target.closest(".card__media");
  if (!card) return;

  const link = card.closest(".card").querySelector("a.full-unstyled-link");
  const imgs = card.querySelectorAll("img");
  if (imgs.length < 2) return;

  // Zweiter Tap → Produkt öffnen
  if (card.dataset.swapped === "true") {
    window.location.href = link.href;
    return;
  }

  // Erster Tap → Bild tauschen
  e.preventDefault();

  const first = imgs[0].src;
  imgs[0].src = imgs[1].src;
  imgs[1].src = first;

  card.dataset.swapped = "true";

  setTimeout(() => {
    card.dataset.swapped = "false";
  }, 1500);
});
